module.exports = __webpack_public_path__ + "static/media/logo-white.7af9ce7e.svg";